<template>
  <SelectServices
    v-bind="serviceData"
    @continue="handleContinue"
    @toggle-service="handleToggleService"
  />
</template>

<script>
import SelectServices from "@/layouts/client/select_services/SelectServices.vue";
import { validateToken } from "@/utils/auth";
import { LOGOUT } from "@/utils/logout.js";
import { API_BASE_URL } from "@/config";

export default {
  name: "InstantServices",
  mixins: [LOGOUT],
  components: {
    SelectServices,
  },
  data: () => ({
    personnel_services: [],
    company_services: [],
    compliance_services: [],
    credit_services: [],
    isLoading: true,
  }),
  computed: {
    applicationId() {
      return this.$store.getters.get_application_id;
    },
    serviceData() {
      return {
        personnelServices: this.personnel_services,
        companyServices: this.company_services,
        complianceServices: this.compliance_services,
        creditServices: this.credit_services,
        isLoading: this.isLoading,
      };
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_services();
    this.get_selected_services();
  },
  methods: {
    get_services() {
      const TOKEN = localStorage.getItem("token");
      const GET_SERVICES_API = `${API_BASE_URL}/verify_api/service_management_api/get_services_api/?instant_verify=true`;

      $.ajax({
        url: GET_SERVICES_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }
          let services = response["services"];
          const SERVICES = Array.isArray(services) ? services : [services];

          SERVICES.forEach((service) => {
            if (service.service_details && service.service_details.length > 0) {
              let category_name =
                service.service_details[0].service_categories.category_name;

              const category_map = {
                personnel_verification: "personnel_services",
                company_verification: "company_services",
                compliance_verification: "compliance_services",
                credit_verification: "credit_services",
              };

              if (category_map[category_name]) {
                this[category_map[category_name]].push(service);
              }
            }
          });
          this.get_selected_services();
        },
        error: () => {
          this.isLoading = false;
        },
      });
    },
    get_selected_services() {
      const TOKEN = localStorage.getItem("token");
      const GET_SELECTED_SERVICES_API = `${API_BASE_URL}/verify_api/workflow_management_api/get_selected_services/`;

      $.ajax({
        url: GET_SELECTED_SERVICES_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }
          const selected_services = Array.isArray(response.all_services)
            ? response.all_services
            : [];
          this.update_service_selection(selected_services);
          this.$nextTick(() => {
            this.isLoading = false;
          });
        },
        error: () => {
          this.isLoading = false;
        },
      });
    },
    update_service_selection(selected_services) {
      const selected_service_ids = selected_services.map(
        (service) => service.service_id
      );

      this.personnel_services = this.personnel_services.map((service) => ({
        ...service,
        is_selected: selected_service_ids.includes(service.id),
      }));

      this.company_services = this.company_services.map((service) => ({
        ...service,
        is_selected: selected_service_ids.includes(service.id),
      }));

      this.compliance_services = this.compliance_services.map((service) => ({
        ...service,
        is_selected: selected_service_ids.includes(service.id),
      }));

      this.credit_services = this.credit_services.map((service) => ({
        ...service,
        is_selected: selected_service_ids.includes(service.id),
      }));
    },
    handleToggleService(service, checked) {
      const updateServiceInArray = (arrayName) => {
        const arr = this[arrayName];
        const index = arr.findIndex((s) => s.id === service.id);
        if (index !== -1) {
          this[arrayName] = [
            ...arr.slice(0, index),
            { ...arr[index], is_selected: checked },
            ...arr.slice(index + 1),
          ];
          return true;
        }
        return false;
      };

      if (
        !updateServiceInArray("personnel_services") &&
        !updateServiceInArray("company_services") &&
        !updateServiceInArray("compliance_services") &&
        !updateServiceInArray("credit_services")
      ) {
        return;
      }

      const updatedService = { ...service, is_selected: checked };
      this.send_service_request(updatedService);
    },
    send_service_request(service) {
      const TOKEN = localStorage.getItem("token");
      const SELECT_SERVICES_API = `${API_BASE_URL}/verify_api/workflow_management_api/instant_verify_request_api/`;

      const FORM_DATA = {
        service_id: service.id,
        is_selected: service.is_selected,
      };

      $.ajax({
        url: SELECT_SERVICES_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(FORM_DATA),
        success: () => {},
        error: () => {
        },
      });
    },
    handleContinue() {
      this.$router.push({ name: "services" });
    },
  },
};
</script>
